module.exports = __webpack_public_path__ + "static/media/03-1-e1667508829231.731c6923.webp";